/**
 * Manifest builders. Manifests use UUIDs and are NOT namespace-derived, so a
 * namespace change leaves them untouched (Section 9.3).
 */

import type { Project } from "../model/types";

export function buildBehaviorManifest(project: Project): unknown {
  const m = project.manifest;
  return {
    format_version: 2,
    header: {
      name: "pack.name",
      description: "pack.description",
      uuid: m.behaviorHeaderUuid,
      version: m.version,
      min_engine_version: m.minEngineVersion,
    },
    modules: [
      { type: "data", uuid: m.behaviorModuleUuid, version: m.version },
      { type: "script", language: "javascript", uuid: m.behaviorScriptUuid, version: m.version, entry: "scripts/main.js" },
    ],
    dependencies: [
      { uuid: m.resourceHeaderUuid, version: m.version },
      { module_name: "@minecraft/server", version: m.serverModuleVersion },
      { module_name: "@minecraft/server-ui", version: m.serverUiModuleVersion },
    ],
    metadata: {
      generated_with: { guidebook_generator: ["0.1.0"] },
    },
  };
}

export function buildResourceManifest(project: Project): unknown {
  const m = project.manifest;
  return {
    format_version: 2,
    header: {
      name: "pack.name",
      description: "pack.description",
      uuid: m.resourceHeaderUuid,
      version: m.version,
      min_engine_version: m.minEngineVersion,
    },
    modules: [{ type: "resources", uuid: m.resourceModuleUuid, version: m.version }],
    dependencies: [{ uuid: m.behaviorHeaderUuid, version: m.version }],
    metadata: {
      generated_with: { guidebook_generator: ["0.1.0"] },
    },
  };
}
